import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["saveState", "buttonLabels", "buttonColors"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { LoadingButton } from '@mui/lab';
import { forwardRef } from 'react';
import { useStyles } from 'tss-react/mui';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultButtonLabels = {
  "default": 'Save',
  saving: 'Saving...',
  success: 'Saved',
  error: 'Save'
};
var defaultButtonColors = {
  "default": 'primary',
  saving: 'primary',
  success: 'success',
  error: 'primary'
};
export var SaveButton = /*#__PURE__*/forwardRef(function SaveButton(_ref, ref) {
  var saveState = _ref.saveState,
      _ref$buttonLabels = _ref.buttonLabels,
      buttonLabels = _ref$buttonLabels === void 0 ? defaultButtonLabels : _ref$buttonLabels,
      _ref$buttonColors = _ref.buttonColors,
      buttonColors = _ref$buttonColors === void 0 ? defaultButtonColors : _ref$buttonColors,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useStyles = useStyles(),
      css = _useStyles.css;

  return /*#__PURE__*/_jsx(LoadingButton, _objectSpread(_objectSpread({
    ref: ref,
    classes: {
      loadingIndicator: css({
        left: 'inherit',
        transform: 'none'
      })
    },
    color: buttonColors[saveState],
    variant: "contained",
    loadingIndicator: buttonLabels.saving,
    loading: saveState === 'saving'
  }, props), {}, {
    children: buttonLabels[saveState]
  }));
});